import React from "react"
import { ExternalLink } from "components"
import styles from "./sponsor.module.scss"

const Sponsor = ({ content, name }) => {
  return (
    <ExternalLink className={styles.sponsor} url={content.url}>
      <img src={content.logo} alt={name} />
    </ExternalLink>
  )
}

export default Sponsor
